import { Balance } from "../../api/api";
import { createSlice } from "@reduxjs/toolkit";
import { setter, unsetter } from "../utils/setter";

export interface BalancesState {
  client_portfolio?:        Balance[]
  client_cash_portfolio?:   Balance[]
  client_margin_portfolio?: Balance[]
}

const initialState: BalancesState = {}

export const balancesSlice = createSlice({
  name: 'balance',
  initialState,
  reducers: {
    setClientPortfolio: setter(initialState, 'client_portfolio'),
    setClientCashPortfolio: setter(initialState, 'client_cash_portfolio'),
    setClientMarginPortfolio: setter(initialState, 'client_margin_portfolio'),
    unsetClientPortfolio: unsetter('client_portfolio'),
    unsetClientCashPortfolio: unsetter('client_cash_portfolio'),
    unsetClientMarginPortfolio: unsetter('client_margin_portfolio')
  }
})
